import api from '@services/api';
import {getUrlParam} from '@utils/url';
import toast from '@components/toast';
import {REVERSE_API_STATUS_MAP} from '@data/apiStatusMap';
import {cheka, CHEKA_EVENTS} from '@utils/cheka';

const suit_id = getUrlParam('suit_id');
let userInfo = {};

export default {
  login() {
    return new Promise((resolve, reject) => {
      api
        .base()
        .get('/ajax/member_suit/show', {params: {suit_id}})
        .then(res => {
          if (!res || !res.data) {
            return reject();
          }
          userInfo = res.data;
          resolve();
        })
        .catch(error => {
          if (error.data && error.data.code && String(error.data.code) === String(REVERSE_API_STATUS_MAP.NOT_LOGGED_IN)) {
            cheka('send', {
              eventid: CHEKA_EVENTS.NOT_LOGIN.id,
              eventtip: 'not_login'
            });
            this.redirectToLogin()
          } else {
            cheka('send', {
              eventid: CHEKA_EVENTS.NOT_LOGIN.id,
              eventtip: 'network_error'
            });
            toast({
              type: 'error',
              content: error.data.message
            });
          }
          reject();
        });
    });
  },
  redirectToLogin() {
    window.location = process.env.VUE_APP_LOGIN_URL + window.encodeURIComponent(window.location.href)
  },
  getUserInfo() {
    return userInfo;
  },
  putOn(params) {
    return api.base().post('/ajax/member_suit/set.json', {suit_id, ...params});
  },
  takeOff() {
    return api.base().post('/ajax/member_suit/remove.json', {suit_id});
  },
  setInteractionIcon(url, params) {
    return api.base().post(url, params);
  },
  setPendant(url, params) {
    return api.engine().get(url, params);
  },
};
